module.exports = __webpack_public_path__ + "static/media/desktop_frame.28f7ad37.svg";